import TextViewer from "../../components/TextViever";

const Scope = () => {
  return <TextViewer obszar="scope" />;
};

export default Scope;
